import styled from 'styled-components';

export const StyledDiv = styled.div`
    background-image: url(${props => props.background}) !important;
`